import { Link } from 'react-router-dom';
import { useFacility } from '../contexts/FacilityContext';
import { TYPE_COLORS } from '../data/facilities';
import './ActiveFacilityBanner.css';

function ActiveFacilityBanner() {
  const { selectedFacility, clearFacility } = useFacility();

  if (!selectedFacility) return null;

  return (
    <div className="active-facility-banner">
      <div className="afb-left">
        <span
          className="afb-dot"
          style={{ background: TYPE_COLORS[selectedFacility.type] || '#00aeef' }}
        />
        <span className="afb-label">Active Facility</span>
        <Link to={`/facility/${selectedFacility.id}`} className="afb-name">
          {selectedFacility.name}
        </Link>
        <span className="afb-location">{selectedFacility.city}, {selectedFacility.state}</span>
      </div>
      <div className="afb-actions">
        <button type="button" className="afb-clear" onClick={clearFacility}>
          Clear
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        </button>
        <Link to="/" className="afb-change">
          Change
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="9 18 15 12 9 6" />
          </svg>
        </Link>
      </div>
    </div>
  );
}

export default ActiveFacilityBanner;
